module.exports = __webpack_public_path__ + "images/d9e7bf8c1c33f72927d2a354c963c25f-illu_panicPendant2.png";